import { render, staticRenderFns } from "./NetworkTab.vue?vue&type=template&id=46fb1936&scoped=true&"
import script from "./NetworkTab.vue?vue&type=script&lang=js&"
export * from "./NetworkTab.vue?vue&type=script&lang=js&"
import style0 from "./NetworkTab.vue?vue&type=style&index=0&id=46fb1936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb1936",
  null
  
)

component.options.__file = "NetworkTab.vue"
export default component.exports